export enum TranskodeTimelineSegmentType {
  Program = "Program",
  DubCard = "DubCard",
  Slate = "Slate",
  Black = "Black",
  White = "White",
  Mire75 = "Mire75",
  Mire100 = "Mire100",
  MireChannelTest = "MireChannelTest",
  Clock = "Clock",
  TextlessMaterial = "TextlessMaterial",
  AudioSilence = "AudioSilence",
  RestorationCard = "RestorationCard",
}
